webpackJsonp([1],{

/***/ "6EPt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__("BS6q");
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8mZv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "92Xv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-container"},[_c('div',{staticClass:"table"},[_c('div',{staticClass:"keys"},_vm._l((_vm.keysFirstHalf),function(key){return _c('span',{staticClass:"tb key"},[_vm._v(_vm._s(key))])})),_c('div',{staticClass:"values"},_vm._l((_vm.valuesFirstHalf),function(value){return _c('span',{staticClass:"tb value"},[_vm._v(_vm._s(value))])}))]),(_vm.isHalf)?_c('div',{staticClass:"table"},[_c('div',{staticClass:"keys"},_vm._l((_vm.keysSecoundHalf),function(key){return _c('span',{staticClass:"tb key"},[_vm._v(_vm._s(key))])})),_c('div',{staticClass:"values"},_vm._l((_vm.valuesSecoundHalf),function(value){return _c('span',{staticClass:"tb value"},[_vm._v(_vm._s(value))])}))]):_vm._e(),(_vm.isHalf)?_c('div',{staticClass:"table"},[_c('div',{staticClass:"keys"},_vm._l((_vm.keysThirdHalf),function(key){return _c('span',{staticClass:"tb key"},[_vm._v(_vm._s(key))])})),_c('div',{staticClass:"values"},_vm._l((_vm.valuesThirdHalf),function(value){return _c('span',{staticClass:"tb value"},[_vm._v(_vm._s(value))])}))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BS6q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");


var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* mixins */].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Pie */],
  mixins: [reactiveProp],
  props: {
    chartData: Object,
    options: Object
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    options: function options() {
      console.log(this.options);
    }
  }
});

/***/ }),

/***/ "HS8f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timeago_js__ = __webpack_require__("8A1c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_timeago_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_timeago_js__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    lastModified: String
  },
  data: function data() {
    return {
      relTime: ''
    };
  },

  created: function created() {
    this.getTimeAgo();
  },
  methods: {
    getTimeAgo: function getTimeAgo() {
      var dateArray = this.lastModified.split(',');
      dateArray[1] = dateArray[1] - 1;
      var lastModified = new Date(Date.UTC(dateArray[0], dateArray[1], dateArray[2], dateArray[3], dateArray[4]));
      this.relTime = __WEBPACK_IMPORTED_MODULE_0_timeago_js___default()().format(lastModified);
    }
  },
  watch: {
    lastModified: function lastModified() {
      this.getTimeAgo();
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e3ef3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kUqf");
function injectStyle (ssrContext) {
  __webpack_require__("8mZv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e3ef3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mt7H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Xc1e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartHeading_vue__ = __webpack_require__("haF0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a36ff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ChartHeading_vue__ = __webpack_require__("cyEN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChartHeading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21a36ff4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_ChartHeading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yon/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      keysFirstHalf: [],
      valuesFirstHalf: [],
      keysSecoundHalf: [],
      valuesSecoundHalf: [],
      keysThirdHalf: [],
      valuesThirdHalf: [],
      isHalf: false
    };
  },

  props: {
    tableData: Object
  },
  mounted: function mounted() {
    this.firstHalf = this.tableData;
    var dataLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tableData).length;

    var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tableData);
    var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.tableData);

    if (dataLength > 20) {
      this.isHalf = true;
      var lengthNum = Math.ceil(dataLength / 3);

      this.keysFirstHalf = keys.slice(0, lengthNum);
      this.valuesFirstHalf = values.slice(0, lengthNum);

      this.keysSecoundHalf = keys.slice(lengthNum, dataLength / 3 * 2);
      this.valuesSecoundHalf = values.slice(lengthNum, dataLength / 3 * 2);

      this.keysThirdHalf = keys.slice(Math.ceil(dataLength / 3 * 2), dataLength);
      this.valuesThirdHalf = values.slice(Math.ceil(dataLength / 3 * 2), dataLength);
    } else {
      this.keysFirstHalf = keys;
      this.valuesFirstHalf = values;
    }
  }
});

/***/ }),

/***/ "a8z3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetTable_vue__ = __webpack_require__("Yon/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa422f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GetTable_vue__ = __webpack_require__("92Xv");
function injectStyle (ssrContext) {
  __webpack_require__("Mt7H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GetTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa422f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_GetTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cyEN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8uv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastUpdated_vue__ = __webpack_require__("HS8f");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff23058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LastUpdated_vue__ = __webpack_require__("ylqj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LastUpdated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fff23058_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_LastUpdated_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "haF0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Object,
    kind: String,
    title: String
  },
  data: function data() {
    return {
      total: '',
      percents: ''
    };
  },

  methods: {
    getChartData: function getChartData() {
      var total = 0;
      var val;

      for (var key in this.data) {
        val = this.data[key];
        total += val;
      }
      this.total = total;
    }
  },
  watch: {
    data: function data() {
      this.getChartData();
    }
  }
});

/***/ }),

/***/ "kUqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"switcher-container"},[_c('button',{staticClass:"switcher",class:{ active: _vm.isChart },on:{"click":function($event){_vm.isChart=!_vm.isChart}}},[_vm._v("Chart")]),_c('button',{staticClass:"switcher",class:{ active: _vm.isTable },on:{"click":function($event){_vm.isTable=!_vm.isTable}}},[_vm._v("Table")])]),_c('div',{staticClass:"site-info"},[_c('h1',[_vm._v("Plugin Stats")]),_c('p',[_vm._v("An unofficial stats page for the plugins that are available in the WordPress.org plugin repository.")]),_c('p',[_vm._v("There are currently "),_c('strong',[_vm._v(_vm._s(_vm.total))]),_vm._v(" plugins in the repo.")])]),_c('div',{staticClass:"wpver-container"},[_c('chart-heading',{staticClass:"heading-wpver",attrs:{"data":_vm.requires,"kind":"req","title":"Required WordPress Versions"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart wpver",attrs:{"width":300,"height":300,"chart-data":_vm.chartData,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.requires}}):_vm._e()],1),_c('div',{staticClass:"wptest-container"},[_c('chart-heading',{staticClass:"heading-wptest",attrs:{"data":_vm.tested,"kind":"tes","title":"Tested WordPress Versions"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart wptest",attrs:{"width":300,"height":300,"chart-data":_vm.chartDataTes,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.tested}}):_vm._e()],1),_c('div',{staticClass:"phpver-container"},[_c('chart-heading',{staticClass:"heading-phpver",attrs:{"data":_vm.requires_php,"kind":"rqp","title":"Required PHP Versions"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart phpver",attrs:{"width":300,"height":300,"chart-data":_vm.chartDataRqp,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.requires_php}}):_vm._e()],1),_c('div',{staticClass:"dl-container"},[_c('chart-heading',{staticClass:"heading-dl",attrs:{"data":_vm.downloads,"kind":"dl","title":"Downloads"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart dl",attrs:{"width":300,"height":300,"chart-data":_vm.chartDataDl,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.downloads}}):_vm._e()],1),_c('div',{staticClass:"installs-container"},[_c('chart-heading',{staticClass:"heading-ins",attrs:{"data":_vm.installs,"kind":"ins","title":"Active Installs"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart ins",attrs:{"width":300,"height":300,"chart-data":_vm.chartDataIns,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.installs}}):_vm._e()],1),_c('div',{staticClass:"dates-container"},[_c('chart-heading',{staticClass:"heading-dates",attrs:{"data":_vm.dates,"kind":"dates","title":"Last Update"}}),(_vm.isChart)?_c('pie-chart',{staticClass:"chart dates",attrs:{"width":300,"height":300,"chart-data":_vm.chartDataDates,"options":_vm.options}}):_vm._e(),(_vm.isTable)?_c('getTable',{attrs:{"table-data":_vm.dates}}):_vm._e()],1),_c('footer',{staticClass:"footer"},[_c('p',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.year)+" Mirucon")]),_vm._m(0),_c('last-updated',{attrs:{"lastModified":_vm.lastModified}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"github"},[_c('a',{attrs:{"href":"https://github.com/Mirucon/plugin-stats","target":"_blank"}},[_vm._v("GitHub")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PieChart__ = __webpack_require__("6EPt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ChartHeading__ = __webpack_require__("Xc1e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_GetTable__ = __webpack_require__("a8z3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_LastUpdated__ = __webpack_require__("h8uv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_palette__ = __webpack_require__("uJoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_google_palette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_google_palette__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_3__components_PieChart__["a" /* default */],
    ChartHeading: __WEBPACK_IMPORTED_MODULE_4__components_ChartHeading__["a" /* default */],
    GetTable: __WEBPACK_IMPORTED_MODULE_5__components_GetTable__["a" /* default */],
    LastUpdated: __WEBPACK_IMPORTED_MODULE_6__components_LastUpdated__["a" /* default */]
  },
  data: function data() {
    return {
      requires: {},
      tested: {},
      requires_php: {},
      downloads: {},
      installs: {},
      dates: {},
      total: '',
      chartData: {},
      chartDataTes: {},
      chartDataRqp: {},
      chartDataDl: {},
      chartDataIns: {},
      chartDataDates: {},
      options: { responsive: true, maintainAspectRatio: true },
      colors: [],
      errors: [],
      lastModified: '',
      year: '',
      isTable: false,
      isChart: true,
      url: 'https://raw.githubusercontent.com/Mirucon/plugin-stats-backend/json/plugins.json'
    };
  },

  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.url).then(function (response) {
      _this.requires = response.data[0];
      _this.tested = response.data[1];
      _this.requires_php = response.data[2];
      _this.downloads = response.data[3];
      _this.installs = response.data[4];
      _this.dates = response.data[5];
      _this.total = response.data[6];
      _this.lastModified = response.data[7];
    }).catch(function (e) {
      _this.errors.push(e);
    });
    var now = new Date();
    this.year = now.getFullYear();
  },
  methods: {
    fillData: function fillData() {
      this.chartData = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.requires),
        datasets: [{
          label: 'Versions that plugins requires',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.requires).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.requires)
        }]
      };
    },
    fillDataTes: function fillDataTes() {
      this.chartDataTes = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tested),
        datasets: [{
          label: 'Versions that plugins tested',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tested).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.tested)
        }]
      };
    },
    fillDataRqp: function fillDataRqp() {
      this.chartDataRqp = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.requires_php),
        datasets: [{
          label: 'PHP Versions that plugins requires',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.requires_php).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.requires_php)
        }]
      };
    },
    fillDataDl: function fillDataDl() {
      this.chartDataDl = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.downloads),
        datasets: [{
          label: 'Number of Downloads',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.downloads).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.downloads)
        }]
      };
    },
    fillDataIns: function fillDataIns() {
      this.chartDataIns = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.installs),
        datasets: [{
          label: 'Number of Active Installs',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.installs).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.installs)
        }]
      };
    },
    fillDataDates: function fillDataDates() {
      this.chartDataDates = {
        labels: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.dates),
        datasets: [{
          label: 'The last updates',
          backgroundColor: __WEBPACK_IMPORTED_MODULE_7_google_palette___default()('tol-sq', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.dates).length).map(function (hex) {
            return '#' + hex;
          }),
          borderWidth: 0.4,
          data: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.dates)
        }]
      };
    }
  },
  mounted: function mounted() {
    this.options.tooltips = {
      callbacks: {
        label: function label(tooltipItem, data) {
          var label = data.labels[tooltipItem.index];
          var dataset = data.datasets[tooltipItem.datasetIndex];
          var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
            return previousValue + currentValue;
          });
          var currentValue = dataset.data[tooltipItem.index];
          var percentage = (currentValue / total * 100 + 0.5).toFixed(1);
          return ' ' + label + ': ' + percentage + '%, ' + currentValue;
        }
      },
      bodyFontSize: 14
    };
  },
  watch: {
    requires: function requires() {
      this.fillData();
    },
    tested: function tested() {
      this.fillDataTes();
    },
    requires_php: function requires_php() {
      this.fillDataRqp();
    },
    downloads: function downloads() {
      this.fillDataDl();
    },
    installs: function installs() {
      this.fillDataIns();
    },
    dates: function dates() {
      this.fillDataDates();
    }
  }
});

/***/ }),

/***/ "ylqj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"last-update"},[_vm._v("Last update: "+_vm._s(_vm.relTime))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.c065c7e27f89a982463e.js